import React, { useState, useContext } from 'react';

export interface SelectedProductContextInterface {
  selectedProduct?: Billing.IProduct;
  setSelectedProduct?: (product: Billing.IProduct) => void;
}

const SelectedProductContext = React.createContext<SelectedProductContextInterface>({});

export const SelectedProductContextProvider: React.FunctionComponent = ({ children }) => {
  const [selectedProduct, setSelectedProduct] = useState();

  return (
    <SelectedProductContext.Provider value={{ selectedProduct, setSelectedProduct }}>
      {children}
    </SelectedProductContext.Provider>
  );
};

export const SelectedProductContextConsumer = SelectedProductContext.Consumer;

export const useSelectedProduct = () => useContext(SelectedProductContext);

export default SelectedProductContext;
